import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../hooks/useLanguage';

// import Star from '../../../svg/star_big.svg';
import Star from '../../../svg/star_white.svg';
import Download from '../../../svg/download_arrow.svg';

const DownloadPdf = ({ downloadPdfData }) => {
  const langToggle = useLanguage;
  // const pdfLink = langToggle(downloadPdfData.pdf_ua, downloadPdfData.pdf_ru);
  const pdfLink = downloadPdfData.pdf_ua;
  return (
    <section className="download-pdf__wrapper" data-scroll-section>
      <div className="content-wrapper">
        <div className="download-pdf">
          <div className="download-pdf__info">
            <span className="download-pdf__info-marker">
              {langToggle(downloadPdfData.marker_ua, downloadPdfData.marker_ru)}
            </span>
            <p className="download-pdf__info-title">
              {langToggle(downloadPdfData.title_ua, downloadPdfData.title_ru)}
            </p>
          </div>
          <a
            href={`https://admin.shoschool.com${pdfLink?.url}`}
            className="download-pdf__link"
            target="blank"
          >
            <Star className="download-pdf__link-star" />
            <span className="download-pdf__link-center">
              <Download className="download-pdf__link-arrow" />
              <span className="download-pdf__link-title">
                {langToggle('завантажити \npdf файл', 'загрузить \npdf файл')}
              </span>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

DownloadPdf.propTypes = {
  downloadPdfData: PropTypes.object,
};

export default DownloadPdf;
